import { Backdrop, Button, CircularProgress, Grid, Stack, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { UserData, UserDataUpdate } from "../../../APIConfig/adminConfig";
import CustomizeInput from "../../../components/CustomizeInput";
import { toast } from "react-toastify";

export const CheckMark = ({ label, onChange, value, name }) => {
  //console.log('value of true and false', value)

  return (
    <Stack direction='row' width="100%" justifyContent='space-between'>
      <Typography style={{ color: "#acacac" }}>
        {label}
      </Typography>
      <input type="checkbox" onChange={onChange} name={name} checked={value ? true : false} />
    </Stack>
  )
}

